import { render, staticRenderFns } from "./comboboxdataapi.vue?vue&type=template&id=988939b8&"
import script from "./comboboxdataapi.vue?vue&type=script&lang=js&"
export * from "./comboboxdataapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports